var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.22 62.82a17.13 17.13 0 01-22.09-7.11c9.42.91 13.05-25.01 32.01-9.3a17.13 17.13 0 01-9.92 16.4z",
    fill: "#86F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.13 55.7a17.14 17.14 0 1132.01-9.25c-19.25-10.9-22.61 10.17-32 9.26z",
    fill: "#B6F5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7 53.3c-1.14-2.51-6.18-2.63-11.24-.3-5.06 2.34-8.23 6.27-7.08 8.77 1.16 2.5 6.2 2.61 11.26.27 5.05-2.33 8.22-6.22 7.06-8.75z",
    fill: "#3FEEF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.13 55.7a16.07 16.07 0 01-.37-14.4c2.16-4.35 5.9-8.09 10.52-9.4 2.32-.68 4.77-.85 7.16-.5 2.42.33 4.76 1.11 6.88 2.32a16.62 16.62 0 015.14 5.16 14.5 14.5 0 012.5 7.03 13.4 13.4 0 00-1.63-7.52c-1.23-2.36-3-4.4-5.17-5.93a19.21 19.21 0 00-15.44-2.4c-2.6.78-4.96 2.19-6.9 4.1a20.13 20.13 0 00-4.47 6.56 15.57 15.57 0 00-1.07 7.8c.32 2.6 1.3 5.08 2.85 7.19z",
    fill: "#95F8FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.84 21.23a10.15 10.15 0 01-7-11.82c3.82 4.11 15.6-5.95 17.84 8.45a10.14 10.14 0 01-10.84 3.37z",
    fill: "#86F8FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.82 9.42l.21-.81a10.14 10.14 0 1117.63 9.25c-4.27-12.37-14.02-4.33-17.84-8.44z",
    fill: "#B6F5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.43 19.6c.48-1.55-1.71-3.6-4.87-4.54-3.15-.94-6.1-.45-6.6 1.1-.5 1.57 1.7 3.6 4.87 4.54 3.17.95 6.12.43 6.6-1.1z",
    fill: "#3FEEF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.32 20.15c.3-.96-1.41-.43-3.16-.98-1.76-.55-2.89-1.9-3.18-.98-.3.94.9 2.18 2.66 2.69 1.75.5 3.4.21 3.68-.73z",
    fill: "#CDFFF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.82 9.42a9.53 9.53 0 015.48-6.5 10.51 10.51 0 018.36-.04c1.29.61 2.43 1.5 3.35 2.59.95 1.09 1.68 2.35 2.15 3.72.4 1.4.48 2.87.25 4.3a8.5 8.5 0 01-1.63 4.1A7.9 7.9 0 0040 13.6c.4-1.53.42-3.13.07-4.68a11.4 11.4 0 00-5.9-7.12A10.06 10.06 0 0029.52.9c-1.58.08-3.13.47-4.56 1.15a9.25 9.25 0 00-5.13 7.37z",
    fill: "#95F8FA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.52 76.87A6.65 6.65 0 014 74.14c3.62.35 5.02-9.64 12.33-3.58a6.65 6.65 0 01-3.82 6.31z",
    fill: "#86F8FA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99 74.14c-.1-.15-.18-.32-.25-.48A6.65 6.65 0 0115.7 68.1c.36.78.56 1.6.6 2.45C8.9 66.38 7.6 74.5 4 74.14z",
    fill: "#B6F5FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.45 73.07c-.45-.97-2.38-1-4.33-.1-1.94.9-3.17 2.4-2.73 3.36.44.96 2.4 1.01 4.34.11 1.95-.9 3.17-2.41 2.72-3.37z",
    fill: "#3FEEF5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.68 74.26c-.28-.6-.88.4-1.96.9-1.07.5-2.2.31-1.96.9.25.59 1.37.66 2.45.16s1.74-1.38 1.47-1.96z",
    fill: "#CDFFF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99 74.14a6.2 6.2 0 01-.15-5.53A6.88 6.88 0 017.89 65a7.03 7.03 0 015.4.7c.81.5 1.49 1.19 2 2 .54.8.87 1.72.95 2.69.07-1-.15-2-.63-2.89a6.46 6.46 0 00-2-2.3 7.33 7.33 0 00-2.85-1.1 6.93 6.93 0 00-3.1.13c-1 .3-1.9.84-2.64 1.58a7.56 7.56 0 00-1.73 2.55 5.9 5.9 0 00.7 5.77z",
    fill: "#95F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.c40285bda9d5824af1631bc259104f4f.svg";
export { ForwardRef as ReactComponent };